const devApiBase = process.env.REACT_APP_API_URL || 'http://localhost:6090';

export const studentsDomain = process.env.REACT_APP_NODE_ENV === "development"
  ? devApiBase
  : (process.env.REACT_APP_NODE_ENV === "staging") ? "https://studentstage.vectorindia.org/" : "https://students.vectorindia.org/";

/** Socket.IO host for live quiz (office app emits events; override if different from API). */
export const quizSocketDomain = (
  process.env.REACT_APP_QUIZ_SOCKET_URL || studentsDomain
).replace(/\/$/, '');

export default { studentsDomain, quizSocketDomain };
